export const ERROR_SERVER = 'Si è verificato un problema. Riprova più tardi.'
export const ERROR_LOGIN = 'Email o password errate. Riprova.'
export const FIELD_REQUIRED = 'Campo obbligatorio.'
export const FIELD_EMAIL_REQUIRED = 'Campo obbligatorio. Inserisci un\'email valida.'
export const ERROR_VERIFY = 'Si è verificato un errore nella validazione dell\'email. Il token potrebbe essere scaduto oppure già utilizzato.'
export const SUCCESS_FORGOT = 'Controlla la tua email e segui le istruzioni.'
export const SUCCESS_RESET = 'Password resimpostata correttamente. Ora puoi accedere con le nuove credenziali.'
